import { PaymentRequestReason } from '@mews-commander/data-access';
import { EnumSelectField } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { PaymentRequestFormField } from '../schema';

export const PaymentRequestFormReasonField = () => (
    <EnumSelectField
        placeholder={lt(TextKey.ProcessPaymentMewsPaymentsPaymentLinkReasonInputplaceholder)}
        required
        name={PaymentRequestFormField.Reason}
        label={lt(TextKey.Reason)}
        helper={lt(TextKey.ProcessPaymentMewsPaymentsPaymentLinkReasonInputHint)}
        enumPrefix="PaymentRequestReason"
        enumClass={PaymentRequestReason}
        enabledValues={Object.values(PaymentRequestReason).filter(
            (value) => value !== PaymentRequestReason.RecurringPayment
        )}
    />
);
